<template>
  <div>
    <!-- Page banner -->
    <Banner main-title="hello" class="centered" typewriterId="Home" :typewriter-delay="900" />

    <!-- "I am Nikos" section -->
<!--    <div class="section">-->
<!--      <p class="section-title">I am <span class="italic-text normal-weight">Nikos</span>.</p>-->

<!--      <p class="section-text">I am a-->
<!--        <span class="italic-text">Greek, goal-oriented, ambitious, enthusiastic, restless and team-player Front-end developer</span>-->
<!--        currently living in Rotterdam, Netherlands. I am always trying to improve and practice my skills as a-->
<!--        front-end developer, while staying true to myself and being honest.-->
<!--      </p>-->

<!--      <router-link :to="{name: ABOUT_ME}" class="link-red section-link">Check out more about me</router-link>-->
<!--    </div>-->

    <!-- Projects section -->
<!--    <div class="section">-->
<!--      <p class="section-title">Projects.</p>-->

<!--      <div class="section-content">-->
<!--        <img-->
<!--            src="https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1740&q=80"-->
<!--            class="image" alt=""/>-->
<!--        <div>-->

<!--          <p class="section-text"><span class="">A small selection</span> projects I have worked on in my free-->
<!--            time and with companies.-->
<!--          </p>-->
<!--          <a class="link-yellow section-link">Check out my projects</a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import Banner from "@/components/v2/Banner";
import {ABOUT_ME} from '@/router/modules/home';
import {userVisitedHome} from "@/setup/firebase/firebaseAnalytics";

export default {
  name: "Home",
  components: {
    Banner
  },
  data: () => ({
    ABOUT_ME,
  }),
  mounted() {
    userVisitedHome();
  },
  metaInfo: {
    title: 'Pertsilis',
    titleTemplate: '%s | Hello.',
    meta: [{
      name: 'description',
      content: 'Experienced front-end web developer in the Netherlands'
    }]
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";
@import "~@/assets/css/base.links";

// Sections
.section {
  margin: 75px 0;
  padding: 0 40px;

  .section-title {
    font-size: 40px;
    font-weight: 900;
    letter-spacing: 5px;
    margin-bottom: 15px;
    text-transform: uppercase;

    .normal-weight {
      font-weight: normal;
    }
  }

  .section-text {
    @extend .font-lato;
    color: var(--gray-main);
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 25px;
    margin-right: auto;
    text-align: justify;
  }

  .section-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;

    .image {
      border-radius: 2px;
      margin-right: 35px;
      width: 100%;
    }
  }

  .section-link {
    font-size: 20px;
  }
}

@media screen and (min-width: $screen-md) {

  // Sections
  .section {
    margin: 60px 0;
    padding: 0 80px;

    .section-title {
      font-size: 52px;
      margin-bottom: 15px;
    }

    .section-text {
      font-size: 18px;
      margin-bottom: 25px;
      margin-right: auto;
      width: 70%;
    }

    .section-content {
      flex-wrap: nowrap;
      margin-top: 40px;

      .image {
        border-radius: 2px;
        margin-right: 35px;
        width: 30%;
      }
    }

    .section-link {
      font-size: 24px;
    }
  }
}
</style>
